import { createFileRoute } from '@tanstack/react-router'
import AssetConnections from 'Asset/components/asset/Sections/AssetConnections'

export const Route = createFileRoute('/assets/$id/connections')({
    component: AssetConnections,
})
